module.exports = __webpack_public_path__ + "img/p29.9bfcaecf.svg";